import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { getConsumerDetail, getConsumerDetailWithStaticToken, sendOtp } from "../../lib/api";
import { useStore } from "../../store";

export default function Home() {
  const [nextUrl, setNextUrl] = useState("");
  const [accesscode, setAccesscode] = useState(false);
  const { userId: id } = useParams();
  console.log(useParams());
  let navigate = useNavigate();
  const setPatient = useStore(state => state.setPatient)
  const setEcg = useStore(state => state.setCurrentEcg)

  useEffect(() => {
    if (id) {
      localStorage.setItem("patientId", id);
    }
    sessionStorage.setItem("isKiosk", true);
    sessionStorage.removeItem("currentVitals");
    setNextUrl("/otp");
    fetchPatient(id);
  }, [id]);

  const next = async () => {
    if (nextUrl == "/otp") {
      setAccesscode(true);
      const data = await sendOtp({
        consumer_id: id,
      });
      console.log(data);
      sessionStorage.setItem("otp_timeout",data?.data?.result?.otp_timeout)
    }
    navigate(nextUrl);
  };
  const fetchPatient = async (id) => {
    const res = await getConsumerDetailWithStaticToken(id);
    console.log(res.data);
    console.log(res?.data?.result?.consumer_details?.id);
    console.log("data.data");
    if (res?.data?.result?.consumer_details) {
      // sessionStorage.setItem(
      //   "patientdata",
      //   JSON.stringify({ ...res?.data?.result?.consumer_details })
      // );
      const patientPhone =
      res?.data?.result?.consumer_details?.contact?.find(
          (e) => e.type == "phone"
        )?.value;
      console.log(patientPhone, "contact");
      if (patientPhone) sessionStorage.setItem("patientPhone", patientPhone);
      setPatient(res?.data?.result?.consumer_details)
    }
    const ecgRes = res?.data?.result?.ecg;
    if ( ecgRes){
      const ecgDetails = ecgRes?.[ecgRes?.length - 1];
      if (ecgRes?.[ecgRes?.length - 1])
        // sessionStorage.setItem(
        //   "currentEcg",
        //   JSON.stringify(ecgDetails)
        // );
      setEcg(ecgDetails)
    }
  };
  return (
    <>
      <div className="bg-primary text-white  px-6 py-8 relative">
        <img
          alt="human"
          src="../../../images/human21.png"
          className="w-72 absolute z-10 top-0 right-0"
        />
        <div className="z-20 relative h-screen flex flex-col sm:w-3/5 mx-auto">
          <div>
            <img
              alt="logo"
              src="../../../images/Logo.svg"
              className="mb-12 sm:mt-20"
            />
          </div>
          <div className="w-3/4 text-3xl sm:hidden">
            Early <br />
            symptom <br />
            assessment <br />
            and triage
          </div>
          <div className="w-3/4 text-3xl hidden sm:block">
            Early symptom assessment <br />
            and triage
          </div>
          <div className="flex-1 flex flex-col justify-end pb-32 sm:pb-40">
            <div className="text-center font-semibold text-2xl">
              Welcome to <b>Prognosis</b>
              <br />
              Click ok to Continue.
            </div>
            {/* <div className="flex mt-5 w-full mx-auto">
              <button className=" flex-1 bg-white rounded-2xl mx-2 text-primary font-semibold text-lg p-3 px-4 flex">
                <div className="flex-1">Sign In</div>
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" 
                    viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" className="w-5 h-7">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M4.5 19.5l15-15m0 0H8.25m11.25 0v11.25" />
                </svg>
                </button>
              <button className=" flex-1 bg-white rounded-2xl mx-2 text-primary font-semibold text-lg  p-3 px-4 flex">
                <div className="flex-1"> Sign Up</div>
                <div className="bg-primary rounded-full h-7 w-7 px-1">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="white" 
                    viewBox="0 0 24 24" strokeWidth="2" stroke="white" className="w-5 h-7">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M4.5 19.5l15-15m0 0H8.25m11.25 0v11.25" />
                </svg>
                </div>
                
                </button>
            </div>  */}
            <div className="text-center">
              {accesscode ? (
                <div className="py-2 text-lg">
                  Please wait we are sending access code to your phone
                </div>
              ) : (
                <button
                  className=" bg-white rounded-2xl  text-primary font-semibold text-lg  py-3 mt-5 pr-2 pl-5 flex mx-auto"
                  onClick={next}
                >
                  <div className="flex-1 pr-3 text-2xl"> Ok</div>
                  <div className="bg-primary rounded-full h-7 w-7 px-1">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="white"
                      viewBox="0 0 24 24"
                      strokeWidth="2"
                      stroke="white"
                      className="w-5 h-7"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M4.5 19.5l15-15m0 0H8.25m11.25 0v11.25"
                      />
                    </svg>
                  </div>
                </button>
              )}
            </div>
            <div className="text-center mt-5 flex gap-5 justify-center">
              <a href="https://versicles.com/privacy-policy/" target="_blank" rel="noopener noreferrer" className="underline">
                Privacy Policy
              </a>
              <a href="https://versicles.com/privacy-policy/" target="_blank" rel="noopener noreferrer" className="underline">
                Term
              </a>
              <Link to="/adminAccess" className="underline">
                Admin
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
